<template>
    <div>
        <el-dropdown :hide-on-click="false" class="mr-5" style="cursor: pointer" trigger="click">
            <el-badge :value="eventsFromStore.length" :max="99" class="item" :hidden="eventsFromStore.length ===0">
                <i class="el-icon-message-solid"/>
            </el-badge>
            <el-dropdown-menu slot="dropdown" class="scrollable">
                <el-dropdown-item v-if="eventsFromStore.length ===0">
                    <span class="text-muted">{{$t('EVENTS.NO_EVENTS')}}
                    </span>
                </el-dropdown-item>
                <el-dropdown-item v-else v-for="event in eventsFromStore" :key="event.eventid">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <div style="cursor:default">
                            <div style="font-size: 1em" class="">{{$t('EVENTS.' + event.type.toUpperCase(), {status:
                                getStatus(event.status)})}}
                            </div>
                            <div class="font-weight-light mt-n3">
                                <span class=" mr-1">{{event.siteName}}</span>
                                <span class="mr-1">- {{event.siloName}}</span>
                            </div>

                            <div class="font-weight-light mr-1 mt-n3">{{$tc('COMMON.SECTION', 1) +' '+ event.section}}
                            </div>
                            <div class="font-weight-light mr-1 mt-n3">{{formatDateOld(event.date)}}</div>
                        </div>
                        <el-button type="text" class="ml-4" style="font-size: 1.1em;" icon="el-icon-delete "
                                   @click="deleteEvent(event)"/>
                    </div>
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
    import api from "../../utils/api/api";
    import dateFormatter from "../../utils/dateFormater";
    import mutations from "../../utils/store/mutations";

    export default {
        name: "eventsBell",
        data: function () {
            return {
                events: [],
                allSites: [],
                interval: undefined

            }
        },
        computed: {
            eventsFromStore: function () {
                if (this.$store.state.events === undefined) {
                    return [];
                }
                return this.$store.state.events;
            },
            silos() {
                if (this.$store.state.sites === undefined) {
                    return [];
                }
                return this.$store.state.sites.map(site => {
                    return site.silos;
                }).flat()
            },
        },
        mounted() {
            this.$store.commit(mutations.DELETE_EVENT, this.$store.state.events);
            api.getEvents().then(value => {
                this.events = value.events.slice(0,400);
                this.events.sort((a, b) => {
                    return a.date - b.date
                });
                this.interval = setInterval(() => {
                    if (this.events.length > 0 && this.silos.length > 0) {
                        clearInterval(this.interval);
                        this.editEvents(this.events, this.silos)
                    }
                }, 1000)

            }).catch(reason => {
                console.error("Error al traer los eventos", reason);
            });
        },
        methods: {
            deleteEvent(event) {
                api.deleteEvent(event.eventid).then(() => {
                    this.$store.commit(mutations.DELETE_EVENT, event);
                }).catch(reason => {
                    this.$message.error("Upps.. ocurrio un error al borrar el evento");
                    console.error("Error al borrar un evento", reason);
                });
            },
            editEvents(events, silos) {
                silos.forEach(silo => {
                    let filteredEvents = events.filter(event => {
                       return silo.siteId.toString() === event.siteid.toString() && event.siloid.toString() === silo.id.toString()
                    });
                    filteredEvents.forEach(event => {
                        event.siteName = silo.siteName;
                        event.siloName = silo.name;
                    })
                });
                 this.$store.commit(mutations.ADD_EVENTS, events);
            },
            formatDate(date) {
                //return dateFormatter.YYYY_MM_DD_HH_MM_SS(new Date(date * 1000));
                return dateFormatter.dateFormat(date,this.$store.state.language);
            },
            formatDateOld(date) {
                let fint;
                fint = dateFormatter.YYYY_MM_DD_HH_MM_SS(new Date(date * 1000))
                return this.formatDate(fint);
            },   
            getStatus(status) {
                const messages = ["", "OK",
                    "WARN",
                    "DANGER"];

                return this.$t('INDICATOR.' + messages[status]);
            }
        }
    }
</script>

<style lang="scss">
    .scrollable {
        max-height: 250px;
        overflow: auto;


        &::-webkit-scrollbar {
            width: 3px;
        }

        /* Track */
        &::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px #fafafa;
            border-radius: 10px;
        }

        /* Handle */
        &::-webkit-scrollbar-thumb {
            background: gray;
            border-radius: 10px;
        }

        /* Handle on hover */
        &::-webkit-scrollbar-thumb:hover {
            background: #fafafa;
        }
    }
</style>